@import "styles/variables";

.status-messages {
	text-align: center;
	padding: 20px 64px;
	background-color: #ffcc33;
  background-image: url(/static/img/info.png);
  background-repeat: no-repeat;
  background-position: center left 20px;
  background-size: 24px;
}

.message {
	margin: 0 auto;
}

.message + .message {
	margin: 1em auto 0;
}